import { useCallback } from 'react';
import { GlobalContext, ModeSettings } from '../../../../context/context';

export function useKeyboardHandlers(
    mode: string | null,
    drawingPolygonPoints: [number, number][],
    drawingLinePoints: [number, number][],
    setModeSettings: (fn: (prev: ModeSettings) => ModeSettings) => void,
    global: GlobalContext,
    addPolygon: (points: [number, number][]) => string | undefined
) {
    return useCallback((e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            setModeSettings(prev => ({
                ...prev,
                mode: "",
                drawingPolygonPoints: [],
                drawingLinePoints: []
            }));
            global.setSelectedShapes([]);
        }
        if (
            e.key === 'Enter' &&
            mode === 'Draw Polygon' &&
            drawingPolygonPoints.length >= 3
        ) {
            addPolygon(drawingPolygonPoints);
            setModeSettings(prev => ({
                ...prev,
                drawingPolygonPoints: []
            }));
        }
    }, [mode, drawingPolygonPoints, drawingLinePoints, setModeSettings, global, addPolygon]);
} 
